module.exports = __webpack_public_path__ + "img/sm-montanera.feef5053.jpg";